export default class RepStatusButton {
	name: string;
	action?: string;
	canDo?: boolean;
	cantDoReason?: string;
	type: StatusButton;
}

export enum StatusButton {
	Activate,
	Deactivate,
	CompleteOnboarding,
	StartOnboarding,
	StartSuspension,
	EndSuspension,
	ExtendContingentStart,
	ContingentlyActivate,
	SetOnHold,
	SetOffHold,
	Terminate,
	Blocklist,
	VersionCopy,
	DeactivateAll,
	ForceActivate,
}
